(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDetailController', SymptomDetailController);

    SymptomDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Symptom', 'Infection', 'Corporation'];

    function SymptomDetailController($scope, $rootScope, $stateParams, previousState, entity, Symptom, Infection, Corporation) {
        var vm = this;

        vm.symptom = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:symptomUpdate', function(event, result) {
            vm.symptom = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
